import { graphql } from '@/gql';

graphql(`
  fragment GrocerySearchItemRowFragment on GrocerySearchItemType {
    id
    name
    productId
    image
    unit
    size
    stockLevel
    quantityAttributes {
      initial
      increment
      min
      max
      quantityType
    }
    pricing {
      badge {
        type
        label
        sublabel
      }
      fullPrice
      price
      pricePerUnit
    }
  }
`);
